export default "//file.bilionpass.com/japandx-portal/0.1.21/static/img/executives-background.8dc858e3-bcff1e.svg";